import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Tooltip } from "react-tooltip";
import profile from "../../assets/img/profile_av.png";
import { useAuth } from '../../hooks/useAuth';
import './Header.css';
import BirthdayAlert from './BirthdayAlert';
import PendingChargesAlert from './PendingChargesAlert';
import WorkWaitingAlert from './WorkWaitingAlert';

const Header = ({ isSidebarClose, handleSidebarToogle, isSidebarOpen, handleSidebarOpen }) => {
    const user = useSelector((state) => state.auth.user);
    const { logout } = useAuth();

    return (
        <header className="page-header sticky-top px-xl-4 px-sm-2 px-0 py-lg-2 py-1">
            <div className="container-fluid">
                <nav className="navbar">
                    <div className="d-flex">
                        <button
                            type="button"
                            className="btn btn-link d-none d-xl-block sidebar-mini-btn p-0 text-primary"
                            onClick={handleSidebarToogle}
                        >
                            <span className={isSidebarClose ? "hamburger-icon active" : "hamburger-icon"}>
                                <span className="line"></span>
                                <span className="line"></span>
                                <span className="line"></span>
                            </span>
                        </button>
                        <button
                            type="button"
                            className="btn btn-link d-block d-xl-none menu-toggle p-0 text-primary"
                            onClick={handleSidebarOpen}
                        >
                            <span className={isSidebarOpen ? "hamburger-icon active" : "hamburger-icon"}>
                                <span className="line"></span>
                                <span className="line"></span>
                                <span className="line"></span>
                            </span>
                        </button>
                    </div>

                    <ul className="header-right justify-content-end d-flex align-items-center mb-0">
                        <WorkWaitingAlert />
                        <PendingChargesAlert />
                        <BirthdayAlert />
                        <li>
                            <div className="dropdown morphing scale-left user-profile mx-lg-3 mx-2">
                                <a 
                                    className="nav-link dropdown-toggle rounded-circle after-none p-0" 
                                    href="#" 
                                    role="button" 
                                    data-bs-toggle="dropdown"
                                >
                                    <img 
                                        className="avatar img-thumbnail rounded-circle shadow" 
                                        src={user?.profileImage || profile} 
                                        alt={user?.name || 'User Avatar'} 
                                    />
                                    {user?.unreadNotifications > 0 && (
                                        <span className="badge rounded-circle bg-primary position-absolute top-0 end-0">{user.unreadNotifications}</span>
                                    )}
                                </a>
                                <div className="dropdown-menu border-0 rounded-4 shadow p-0">
                                    <div className="card border-0 w300">
                                        {/* Clean Profile Header */}
                                        <div className="profile-dropdown-header d-flex align-items-start">
                                            <img 
                                                className="profile-avatar me-3" 
                                                src={user?.profileImage || profile} 
                                                alt={user?.name || 'User Avatar'} 
                                            />
                                            <div className="profile-info">
                                                <div className="profile-name">{user?.name || 'User'}</div>
                                                <div className="profile-email">{user?.email || 'user@example.com'}</div>
                                                <div className="profile-badge">{user?.userGroup || 'USER'}</div>
                                            </div>
                                        </div>
                                        
                                        {/* Clean Menu Items */}
                                        <div className="list-group list-group-flush">
                                            <Link 
                                                to="/my-profile" 
                                                className="profile-menu-item list-group-item list-group-item-action text-decoration-none"
                                            >
                                                <div className="menu-icon">
                                                    <i className="fa fa-user"></i>
                                                </div>
                                                <div className="menu-content">
                                                    <h6>My Profile</h6>
                                                    <small>Account settings and more</small>
                                                </div>
                                            </Link>
                                            
                                            {user?.userGroup === 'ADMIN' && (
                                                <Link 
                                                    to="/manage-team" 
                                                    className="profile-menu-item list-group-item list-group-item-action text-decoration-none"
                                                >
                                                    <div className="menu-icon">
                                                        <i className="fa fa-users"></i>
                                                    </div>
                                                    <div className="menu-content">
                                                        <h6>Manage Team</h6>
                                                        <small>User management and roles</small>
                                                    </div>
                                                </Link>
                                            )}
                                        </div>

                                        {/* Clean Sign Out Button */}
                                        <button 
                                            onClick={logout}
                                            className="profile-signout-btn"
                                        >
                                            <i className="fa fa-sign-out"></i>
                                            Sign Out
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;
